// extracted by mini-css-extract-plugin
export default {"label":"CustomCheckbox_label__DDZhV","input":"CustomCheckbox_input__Eelc3"};